// Web addresses in the text, drawn as links. A click opens one in a new tab;
// a drag across it still selects, and the text stays editable.
import { findLinks } from '@/app/links/links';
import {
  type EditorState,
  StateField,
} from '@codemirror/state';
import {
  Decoration,
  type DecorationSet,
  EditorView,
} from '@codemirror/view';

const marks = (state: EditorState): DecorationSet =>
  Decoration.set(
    findLinks(state.doc.toString()).map(link =>
      Decoration.mark({
        class: 'note-link',
        attributes: { 'data-url': link.url },
      }).range(link.from, link.to)
    ),
  );

const decorations = StateField.define<DecorationSet>({
  create: marks,
  update: (set, tr) => tr.docChanged ? marks(tr.state) : set,
  provide: field => EditorView.decorations.from(field),
});

const linkAt = (target: EventTarget | null) =>
  target instanceof Element
    ? target.closest<HTMLElement>('.note-link')?.dataset['url']
    : undefined;

const clicks = EditorView.domEventHandlers({
  click: (e, view) => {
    const url = linkAt(e.target);
    if (!url || e.button !== 0 || !view.state.selection.main.empty) {
      return false;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
    return true;
  },
});

export const links = [decorations, clicks];
